"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToAuthorLineProps({ data }) {
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    };
    // Question for Brenden: For some reason, our SylexTypes file is typing authorLine as a string, when the data is
    // actually an object. The first and last name are getting auto-pulled in based on the user. It's probably a bug with
    // the way the hook is getting the data (it does work though)
    const authorLine = data?.authorLine;
    return {
        firstName: authorLine?.firstName || '',
        lastName: authorLine?.lastName || '',
        publishDate: formatDate(data.publishDate),
    };
}
exports.default = mapToAuthorLineProps;
